import { BarChart, XAxis, YAxis, Tooltip, Bar, Legend } from "recharts";
import { getRandomColor } from "../../../helpers/helper";
import { getGraphDetails } from "./ChartUtils";
const CustomBarChart = ({
  maxHeight,
  chartData,
  seriesMap,
  compact = true,
}) => {
  const [xDataKey, yDataKeys, data] = getGraphDetails(chartData, seriesMap);

  const tooltipLabelFormatter = (_, payload) => {
    const p = payload?.[0]?.payload || {};
    return p[xDataKey] ?? p.label ?? ""; // LABEL (X)
  };
  // #endregion
  return (
    <BarChart
      style={{
        width: compact ? 120 : "100%",
        maxHeight: maxHeight || 300,
        aspectRatio: 1.618,
        border: compact ? "1px solid #" + getRandomColor() : "",
      }}
      responsive
      data={data}
      margin={{
        top: 0,
        right: 10,
        bottom: 0,
        left: 0,
      }}
    >
      {!compact && <XAxis dataKey={xDataKey} />}
      {!compact && <YAxis width="auto" />}
      <Tooltip
        labelFormatter={tooltipLabelFormatter}
        position={{ x: -150, y: 0 }}
        wrapperStyle={{ zIndex: 2147483647 }}
      />
      <Legend
        iconType="circle"
        iconSize={6} // tiny circle
        wrapperStyle={{
          fontSize: "10px", // xx-small
          paddingTop: "4px",
        }}
      />

      {yDataKeys.map((key) => {
        return (
          <Bar
            dataKey={key}
            barSize={12}
            barGap={0}
            
            fill={getRandomColor()}
            isAnimationActive={true}
            activeBar={{ stroke: getRandomColor()}}
          />
        );
      })}
    </BarChart>
  );
};
export default CustomBarChart;
